import { Password } from '@phosphor-icons/react';
import { Member } from './Member';

import { HookObject, ListItemsHooks } from "@/plugins/types";
import { Dashboard } from "./Dashboard";

export const onListItems = (hook: HookObject, _, __, { permissions = [] }) => {
  if (hook.id === ListItemsHooks.APP_DRAWER && hook.position === "top") {
    if (!permissions.includes("member")) return [];
    return [
      {
        label: "Member",
        icon: <Password className="text-lg" />,
        href: "/member",
        order: 8,
      },
    ];
  }

  if (hook.id === ListItemsHooks.ROUTES) {
    if (!permissions.includes("member")) return [];
    return [
      {
        path: "/member",
        element: <Member name="Membership Sites" />,
        children: [
          {
            path: ":id",
            element: <Dashboard name="Membership Sites" />,
          },
        ],
      },
    ];
  }
};


export { Member };